// Mínimo SNR decodificable por Chirpstack DR (EU868): DR0=SF12 … DR5=SF7
const DR_MIN_SNR = [-20, -17.5, -15, -12.5, -10, -7.5];

export function linkQuality(snr, dr) {
  if (snr == null || dr == null) return null;
  const minSnr = DR_MIN_SNR[Math.min(Math.max(Math.round(dr), 0), 5)];
  return Math.min(100, Math.max(0, Math.round((snr - minSnr) / 20 * 100)));
}

export function qualityColor(q) {
  if (q == null) return '#999';
  if (q >= 70) return '#16a34a';
  if (q >= 40) return '#d97706';
  return '#dc2626';
}
